function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import InputLabel from "./InputLabel";
import ErrorContainer from "./ErrorContainer";
import { _CoreInputWrapper, _InputWrapperDiv, _NumberInput, InputBlockDiv, InputPrefix } from "./inputStyles";
import uuid from 'uuid/v4';
var ScoreInput = /*#__PURE__*/function (_React$Component) {
  _inherits(ScoreInput, _React$Component);
  var _super = _createSuper(ScoreInput);
  function ScoreInput(props) {
    var _this;
    _classCallCheck(this, ScoreInput);
    _this = _super.call(this, props);
    _this.id = uuid();
    _this.state = {
      focused: false,
      validation: null
    };
    _this.updateValidation = _this.updateValidation.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ScoreInput, [{
    key: "updateValidation",
    value: function updateValidation(propsParam) {
      var props = propsParam || this.props;
      var validation = null;
      var inputValue = props.inputValue;
      var minScore = parseFloat(props.min);
      var maxScore = parseFloat(props.max);

      // if inputValue is greater or less than defined min or max, throw error
      if (inputValue != null && (inputValue < minScore || inputValue > maxScore || props.validationError)) {
        validation = 'error';
      }
      if (validation !== this.state.validation) {
        this.setState({
          validation: validation
        });
      }
      return validation;
    }

    // eslint-disable-next-line react/no-deprecated
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.updateValidation(nextProps);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateValidation();
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.setState({
        focused: true
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        focused: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      // change input background to pink if error occurs,
      var errorBackground = this.state.validation === 'error' ? 'pink' : 'white';
      var classNames = [this.props.className, value !== '' ? null : 'empty', this.state.focused ? 'focus' : null, this.state.validation === 'error' ? 'error' : null, 'number-input'];
      var wrapperClassName = [this.props.required ? 'required' : null, 'score-input'].filter(function (e) {
        return !!e;
      }).join(' ');
      var className = classNames.filter(function (e) {
        return !!e;
      }).join(' ');
      var value = (this.props.inputValue === 0 ? '0' : !this.props.inputValue ? '' : this.props.inputValue) || (this.props.input && this.props.input.value === 0 ? '0' : !(this.props.input && this.props.input.value) ? '' : this.props.input && this.props.input.value);
      var elementClassName = value === '' ? 'empty' : null;
      return /*#__PURE__*/React.createElement(_CoreInputWrapper, {
        className: wrapperClassName
      }, /*#__PURE__*/React.createElement(_InputWrapperDiv, null, /*#__PURE__*/React.createElement(InputLabel, {
        htmlFor: this.id,
        labelText: props.labelText,
        required: props.required
      })), /*#__PURE__*/React.createElement(_InputWrapperDiv, {
        noPadding: props.noPadding
      }, /*#__PURE__*/React.createElement(InputBlockDiv, {
        className: className,
        disabled: props.disabled
      }, this.props.prefix !== undefined && (!this.props.onlyDisplayPrefixWithValue || value !== '') && /*#__PURE__*/React.createElement(InputPrefix, null, this.props.prefix), /*#__PURE__*/React.createElement(_NumberInput, _extends({
        id: this.id
      }, props, props.input, {
        className: elementClassName,
        css: "\n                background: ".concat(props.disabled ? '#F9F9F9' : errorBackground, ";\n              "),
        "data-inputid": props.inputId,
        empty: elementClassName,
        onBlur: this.onBlur,
        onChange: props.onChange || props.input && props.input.onChange,
        onFocus: this.onFocus,
        onKeyDown: this.props.onKeyDown,
        type: "number",
        value: value
      })), this.props.suffix !== undefined && (!this.props.onlyDisplaySuffixWithValue || value !== '') && /*#__PURE__*/React.createElement(InputPrefix, null, this.props.suffix)), /*#__PURE__*/React.createElement(ErrorContainer, {
        error: props.error
      })));
    }
  }]);
  return ScoreInput;
}(React.Component);
var stringOrNumber = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
ScoreInput.propTypes = {
  name: PropTypes.string,
  inputId: PropTypes.string,
  inputValue: stringOrNumber,
  required: PropTypes.bool,
  className: PropTypes.string,
  min: stringOrNumber,
  max: stringOrNumber,
  error: PropTypes.string,
  onlyDisplayPrefixWithValue: PropTypes.bool,
  onlyDisplaySuffixWithValue: PropTypes.bool,
  prefix: stringOrNumber,
  suffix: stringOrNumber
};
ScoreInput.defaultProps = {
  onlyDisplayPrefixWithValue: false,
  onlyDisplaySuffixWithValue: false,
  prefix: undefined,
  suffix: undefined
};
export default ScoreInput;